export default __webpack_public_path__ + "static/media/gallery_15.6149df9c.jpg";